import { useAppDispatch, useAppSelector } from 'hooks/redux';
import React, { useEffect, useRef, useState } from 'react';
import { MapElementIcon } from 'components/UI/MapElementIcon';
import { IconButton } from '@mui/material';
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import { TooltipMapIcon } from 'components/UI/TooltipMapIcon';
import { getText } from 'services/languageService';
import { toggleOpenFullscreenAction } from 'store/actions/map';

export const FullscreenElement: React.FC = (): JSX.Element => {
  const { openFullscreen } = useAppSelector((state) => state.map);
  const dispatch = useAppDispatch();

  const toggleFullscreenMode = () => {
    dispatch(toggleOpenFullscreenAction(!openFullscreen));
  };

  return (
    <TooltipMapIcon title={getText('FULLSCREEN_TL')}>
      <MapElementIcon>
        <IconButton
          aria-label="fs"
          onClick={toggleFullscreenMode}
          id={'fs-btn'}
        >
          {openFullscreen ? <CloseFullscreenIcon /> : <OpenInFullIcon />}
        </IconButton>
      </MapElementIcon>
    </TooltipMapIcon>
  );
};
